import service, { PandoResponse } from '..';

export interface DeliveryInfo {
  DateApproved: string;
  DateCreated: string;
  DateFulfilled?: string | null;
  DeliveryEta?: string | null;
  OrderId: string;
  OrderStatus: string;
  PackageStatus: number;
  PackageTracker?: string | null;
  TrackingNumber?: string | null;
}

const getDeliveryInfo = async (
  {
    accountGuid,
    orderStatus,
  }: {
    accountGuid: string;
    orderStatus?: string;
  },
  { accessToken }: { accessToken: string }
) => {
  const query = new URLSearchParams(
    JSON.parse(JSON.stringify({ orderStatus }))
  ).toString();
  const response = service.get<PandoResponse<DeliveryInfo[]>>(
    `/api/deliveryInfo`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        AccountGuid: accountGuid,
        Query: query,
      },
    }
  );
  return response;
};

export default getDeliveryInfo;
